import * as categories from '../categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, PERFORMANCE, ADVERTISING } from '../constants';
import Cookies from 'js-cookie';
import { accessNested } from 'utils/utils';

function addHandlerToCookieAccept() {
	let cookie = Cookies.get('sme_cookie_en');
	const acceptButton = document.getElementById('sme_cookie_accept');

	if (!acceptButton && !cookie) {
		window.setTimeout(addHandlerToCookieAccept, 100);
		return;
	}

	if (cookie) {
		categories.set([STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING, PERFORMANCE]);
		return;
	}

	acceptButton.addEventListener('click', () => {
		categories.set([STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING, PERFORMANCE]);
	});
}

if (typeof window !== 'undefined') {
	const useSME = accessNested(window , '__INITIAL_STATE__.appData.options.SMECookieConsent', false);
	if (useSME) {
		addHandlerToCookieAccept();
	}
}